import { styles } from './ContentBlock.styles';

export interface ContentBlockProps {
  title: string;
  text: string;
}

/**
 * Компонент для отображения блока контента с заголовком и текстом
 */
export function ContentBlock({ title, text }: ContentBlockProps) {
  const slots = styles();

  return (
    <div>
      <h4 className={slots.title()}>{title}</h4>
      <p className={slots.text()}>{text}</p>
    </div>
  );
}
